export default __webpack_public_path__ + "static/champion-htf-welterweight-webfont-e305c1882950dcc5e311e2b908dbb542.ttf";